export const VISION_URL_REGISTRATION_STORAGE_KEY = 'vision:url-registered:v1'
